import script from "./VReplySetSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VReplySetSelect.vue?vue&type=script&lang=ts&setup=true"

import "./VReplySetSelect.vue?vue&type=style&index=0&id=5e3a2ba2&lang=sass"

const __exports__ = script;

export default __exports__